// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_UbX8k","news":"index_news_bFvui","text":"index_text_H1zb-"};